exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".starter-pc-hero-section .starter-pc-content .starter-pc-review .vue-star-rating-star {\n  margin: 0;\n}", ""]);

// exports
